// extracted by mini-css-extract-plugin
export default {"l":"CoinSlider_l__g+QxM","o":"CoinSlider_o__E8DtV","wrap":"CoinSlider_wrap__Zpo4M","btn":"CoinSlider_btn__borCl","opt":"CoinSlider_opt__A9XgW"};